import { useScrollPosition } from "@/hooks";
import { useEffect, useState } from "react";
import { AnchorContext } from "./AnchorContext";

interface AnchorGroupProps {
    children?: React.ReactNode | React.ReactNode[];
}

const AnchorGroup = ({ children }: AnchorGroupProps) => {
    const [active, setActive] = useState<string>("block-1");
    const [, top] = useScrollPosition();

    useEffect(() => {
        const anchors = document.querySelectorAll("[id^='block-']");

        let closestAnchor = null;
        let closestDistance = Infinity;

        anchors.forEach((anchor) => {
            const anchorTop = anchor.getBoundingClientRect().top + window.scrollY;
            const distance = anchorTop - top + anchor.clientHeight / 2 - 160;

            const absDistance = Math.abs(distance);
            const absClosestDistance = Math.abs(closestDistance);

            if (absDistance < absClosestDistance) {
                closestDistance = distance;
                closestAnchor = anchor.id;
            }
        });

        if (closestAnchor) {
            setActive(closestAnchor);
        }
    }, [children, top]);

    return (
        <AnchorContext.Provider value={active}>
            <div
                id="anchors-navigation"
                className="flex flex-col row-span-full gap-2 sticky left-0 self-start select-none top-[175px] mb-2"
            >
                {children}
            </div>
        </AnchorContext.Provider>
    );
};

export default AnchorGroup;
